if (!customElements.get('mini-cart')) {  
  class MiniCart extends HTMLElement {
    constructor() {
      super();
      this.cartModalOpen = false;
    }

    connectedCallback() {
      this.cartUrl = this.dataset.cartUrl;
      this.sectionId = this.dataset.sectionId;
      this.cart = JSON.parse(this.dataset.cartJson) || null;
      this.isFullCart = this.dataset.fullCart === 'true';
      this.classList.remove('loading');
      this.showNotifications = this.dataset.showNotifications == 'true' ? true : false;
      
      window.addEventListener('cartGWP:updated', (e) => {
        this.updateCartHtml(e.detail, true);
      });
      
      document.addEventListener('DOMContentLoaded', () => {
        this.init();
      });
      if (document.readyState === 'complete') this.init();

      //AB TESTING  STUFF
      const observer = new MutationObserver(() => {
        this.showNotifications = this.dataset.showNotifications === 'true';
      });

      observer.observe(this, {
        attributes: true,
        attributeFilter: ['data-show-notifications']
      });
      //END AB TESTING  STUFF
    }
    
    init() {
      this.addDelegatedClickListeners();
      this.getRecommendedProducts();
    }
    
    addDelegatedClickListeners() { 
      document.addEventListener('click', (e) => {
        if (!this.isConnected) return;
        if (window.location.pathname === this.cartUrl) return;
        if(e.target.closest(`[href="${this.cartUrl}"]`)) {
            e.preventDefault();
            this._openTrigger = e.target.closest(`[href="${this.cartUrl}"]`);
            this.open();
            return;
        }
        if (e.target.closest('[data-persist-cart]')) return
        if (e.target.closest('[data-close-cart]') && this.cartModalOpen) {
            this.close();
            return;
        }
        if (!e.target.closest('mini-cart') && this.cartModalOpen) {
            this.close();
            return;
        }
      });


      window.addEventListener('submit', function (e) {
        const productForm = e.target.closest(`[action="${Shopify.routes.root}cart/add"]`);
        if (!productForm) return;

        e.preventDefault();
      
        const idInput = productForm.querySelector('[name="id"]');
        const quantityInput = productForm.querySelector('[name="quantity"]');
        const sellingPlanInput = productForm.querySelector('input[name="selling_plan"]:checked');


        const propertyInputs = productForm.querySelectorAll('[data-form-property]');
        const submitButton = e.submitter || productForm.querySelector('[type="submit"]');
        
        const sellingPlan = sellingPlanInput?.value || null;
        const idToAdd = idInput?.value;
        const quantity = quantityInput?.value;
        const properties = {};

        let selling_plan = null;
        if (sellingPlanInput && sellingPlanInput.value !== '') {
          selling_plan = sellingPlanInput.value;
        }
      
        let discount = null;
        const discountInput = productForm.querySelector('[name="properties[Discount]"]');
        if (discountInput && discountInput.value !== undefined) {
          discount = discountInput.value;
        }
      
        propertyInputs.forEach(input => {
          const key = input.getAttribute('name').replace(/.*\[(.*)\].*/, '$1');
          properties[key] = input.value;
        });
      
        const editFormId = productForm.dataset.edit || false;
        const _this = this;
      
        submitButton.classList.add('loading');
      
        const proceedAddToCart = () => {
          _this.addToCart(idToAdd, sellingPlan, discount, quantity, properties)
            .then(() => {
              if (!this.showNotifications) {
                if (document.querySelector('custom-modal')?.activeId) {
                  window.dispatchEvent(new CustomEvent('modal:close'));
                  if (!this.isFullCart && window.location.pathname !== this.cartUrl) { _this._openTrigger = submitButton; setTimeout(() => _this.open(), 500); }
                } else {
                  if (!this.isFullCart && window.location.pathname !== this.cartUrl) { _this._openTrigger = submitButton; _this.open(); }
                }
              }
              window.dispatchEvent(new CustomEvent('cart:updated'));
            })
            .finally(() => {
                submitButton.classList.remove('loading')
                _this.classList.remove('loading');

            });
        };
      
        if (editFormId) {
          _this.classList.add('loading');
          fetch(`${Shopify.routes.root}cart/change.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: editFormId, quantity: 0 }),
          })
            .then(response => response.json())
            .then(proceedAddToCart);
        } else {
          proceedAddToCart();
        }
      }.bind(this));
      

      

      this.addEventListener('click', (e) => {
        const clickedElement = e.target.closest('[data-cart-action]');
        if (!clickedElement) return;

        const {
          cartAction: action,
          lineItemId,
          quantity,
          sellingPlan,
        } = clickedElement.dataset;
        
        switch (action) {
          case 'updateQty':
            const scrollTop = this.querySelector('form')?.scrollTop;

            this.classList.add('loading');
            this.updateQty(lineItemId, Number(quantity))
              .then((res) => {
                if (!res) return;
                this.updateCartHtml(res).then(() => {
                  this.querySelector('form')?.scrollTo({ top: scrollTop, left: 0, behavior: 'auto' });
                });
                this.getRecommendedProducts();
                window.dispatchEvent(new CustomEvent('cart:updated'));
              }).finally(() => this.classList.remove('loading'));
          break;

          case 'toggle-subscription':
            this.classList.add('loading');
            this.upgradeToSubscription(lineItemId, Number(quantity), Number(sellingPlan) || null)
              .then((res) => {
                if (!res) return;
                this.updateCartHtml(res).then(() => {
                  this.querySelector('form')?.scrollTo({ top: scrollTop, left: 0, behavior: 'auto' });
                });
                this.getRecommendedProducts();
                window.dispatchEvent(new CustomEvent('cart:updated'));
              }).finally(() => this.classList.remove('loading'));
          break;
          default: break;
        }
      })

      document.addEventListener('keydown', (e) => {
        if (!this.isConnected) return;
        if (e.key === 'Escape' && this.cartModalOpen) this.close();
      });

      this.addEventListener('keydown', (e) => {
        if (!this.cartModalOpen || e.key !== 'Tab') return;
        const focusable = [...this.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )].filter(el => el.offsetParent !== null);
        if (focusable.length === 0) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey) {
          if (document.activeElement === first) { e.preventDefault(); last.focus(); }
        } else {
          if (document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
      });

      this.addEventListener('change', (e) => {
        const clickedElement = e.target.closest('[data-cart-action="change-selling-plan"]');
        if (!clickedElement) return;

        const {
          lineItemId,
          quantity,
        } = clickedElement.dataset;

        const sellingPlan = Number(clickedElement.value);
        const scrollTop = this.querySelector('form')?.scrollTop;

        this.classList.add('loading');
        this.upgradeToSubscription(lineItemId, Number(quantity), sellingPlan)
          .then((res) => {
            if (!res) return;
            this.updateCartHtml(res).then(() => {
              this.querySelector('form')?.scrollTo({ top: scrollTop, left: 0, behavior: 'auto' });
            });
            this.getRecommendedProducts();
            window.dispatchEvent(new CustomEvent('cart:updated'));
          }).finally(() => this.classList.remove('loading'));
      });
    }
    
    open() {
      this.cartModalOpen = true;
      this.removeAttribute('inert');
      this.classList.remove('translate-x-full');
      document.querySelector('.section-header').classList.replace('z-10', 'z-[5]');
      if (!window.location.href.includes('/cart')) document.body.classList.add('overlay');

      const gorgias_container = document.querySelector('#gorgias-chat-container');
      if (gorgias_container) gorgias_container.style.zIndex = '-1';

      requestAnimationFrame(() => {
        this.querySelector('[data-close-cart]')?.focus();
      });

      // document.querySelectorAll('.needsclick').forEach((needsclick_el) => {
      //   needsclick_el.style.zIndex = '-1';
      // });
    }

    close() {
      this.cartModalOpen = false;
      this.classList.add('translate-x-full');
      this.setAttribute('inert', '');
      document.querySelector('.section-header').classList.replace('z-[5]', 'z-10');
      document.body.classList.remove('overlay');

      const gorgias_container = document.querySelector('#gorgias-chat-container');
      if (gorgias_container) gorgias_container.style.zIndex = '31';

      if (this._openTrigger) {
        this._openTrigger.focus();
        this._openTrigger = null;
      }

      // document.querySelectorAll('.needsclick').forEach((needsclick_el) => {
      //   needsclick_el.style.zIndex = '31';
      // });
    }
    
    getRecommendedProducts() {
      if (!this.cart?.items.length) return;
      const recommendationsWrapper = this.querySelector('[data-recommended-product-row]');
      if (!recommendationsWrapper) return;
      
      const reccsToRenderPerCartItem = Math.round(5/this.cart.items.length);
      recommendationsWrapper.innerHTML = '';
      
      for (let i = 0; i < this.cart.items.length; i++) {
        const item = this.cart.items[i];
        fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${item.product_id}`)
          .then(response => {
            return response.json()
          })
          .then(({ products }) => {
            const filteredReccs = products
              .filter(({ id, tags }) => {
                return !this.cart.items.find(({ product_id }) => id == product_id) 
                && !tags.some(tag => tag === ('hide_product' || 'base_product'))
              })
              .slice(0, reccsToRenderPerCartItem)
            
              recommendationsWrapper.innerHTML += filteredReccs.map((recc) => {
                return `
                <li>
                  <intersection-loader 
                    data-url="/products/${recc.handle}" 
                    data-section-id="quickbuy-widget"
                    class="bg-silverSand"
                    style="width: 284px; height: 194px;"
                  >
                    <div class="loader">
                      <span class="block w-12 h-12">
                        <svg class="animate-spin -ml-1 mr-3 h-full w-full text-accent1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                      </span>
                    </div>
                  </intersection-loader>
                </li>`;
              }).join('');
          })
      }
    }

    async addToCart(id, selling_plan = null, discount = null, quantity, properties) {
      const data = {
        id,
        quantity,
        sections: [`${this.sectionId}`]
      };
    
      if (properties && Object.keys(properties).length !== 0) {
        data.properties = properties;
        if (discount) data.properties['Discount'] = discount;
      }
    
      if (selling_plan) {
        data.selling_plan = selling_plan;
      }
    
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
          },
          body: JSON.stringify(data)
        });
    
        const json = await response.json();
        if(this.showNotifications) this.showNotification(json);
        this.updateCartHtml(json);

        this.getRecommendedProducts();

        window.FastSimonSDK.event({
          reportAppType: "SPA",
          eventName: window.FastSimonEventName.AddToCartPerformed,
          data: {
            productID: id
          }
        });
    
        return json;
      } catch (err) {
        console.error('Add to cart error:', err);
      }
    }
    

    async updateCartHtml(res, updateOnlyProducts = false) {
      let newHtml;
      if (res && !this.isFullCart) {
       newHtml = res?.sections?.[`${this.sectionId}`] ?? res?.sections?.['minicart'];
      } else {
        const sectionRes = await fetch(`${this.cartUrl}?sections=${this.sectionId}`);
        const sectionJson = await sectionRes.json();
        newHtml = sectionJson[this.sectionId];
      }

      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = newHtml;
      
      if (updateOnlyProducts) {
        this.querySelector('[data-cart-items]').innerHTML = tempDiv.querySelector('[data-cart-items]').innerHTML;
      } else {
        this.innerHTML = tempDiv.querySelector('mini-cart').innerHTML;        
      }
      
      const count = Number(tempDiv.querySelector('mini-cart').dataset.cartItemCount) || '';
      this.cart = JSON.parse(tempDiv.querySelector('mini-cart').dataset.cartJson) || null;
      [...document.querySelectorAll('[data-cart-count]')].forEach(cartCount => {
        cartCount.innerHTML = count > 0 ? count : '';
      });     
      
      document.dispatchEvent(new CustomEvent('cart-updated', {
        detail: {
          cart: this.cart,
        }
      }));

      if (this.cartModalOpen) {
        requestAnimationFrame(() => {
          this.querySelector('[data-close-cart]')?.focus();
        });
      }
    }
    
    async updateQty(id, qty) {
      const updates = {};
      updates[id] = qty;

      const data = {
        updates,
        sections: [`${this.sectionId}`],
      };

      const cartContents = fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error('Error:', error);
        });

      return cartContents;
    };

     async upgradeToSubscription(id, quantity, selling_plan = null) {
      const data = {
        id,
        quantity,
        selling_plan,
        sections: [`${this.sectionId}`],
      };

      const cartContents = fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .catch((error) => {
          console.error('Error:', error);
        });

      return cartContents;
    };

    showNotification(json) {
      const modal = document.querySelector('custom-modal');
      modal.innerHTML = '';
      const template = this.querySelector('[data-drawer-content="cart-notification"]');
      if (!template) return;

      const content = template.content.cloneNode(true);
      const item_target = content.querySelector('[data-notification-content]');
      const rec_target = content.querySelector('[data-recommend-content]');

      if (item_target) {
        item_target.innerHTML = `
          <div class="flex gap-14 p-4 rounded-lg bg-primaryLight">
            <div> 
              <img src="${json.featured_image.url}&width=150" alt="${json.title}" width="200" loading="lazy" class="object-cover max-w-[98px] md:max-w-[130px] max-h-[69px] aspect-[31/22] mix-blend-multiply">
            </div>
            <div class="flex flex-col gap-1">
              <span class="text-base font-semibold">${json.title.split(' - ')[0]}</span>
              <ul class="text-sm flex flex-col opacity-75">
                ${(json.options_with_values || []).map(opt => 
                  `<li>${opt.name}: ${opt.value}</li>`
                ).join('')}
              </ul>
            </div>
          </div>
        `;
      }
      if (rec_target && json.properties) {

        const category = json.properties._category?.toLowerCase() || '';
        const gender = json.properties._gender?.toLowerCase();

        let matchAttr = 'data-all-bestsellers';
        if (gender === 'men') {
          if (category == 'footwear') matchAttr = 'data-mens-shoes';
          else if (category == 'insole' || category == 'sock') matchAttr = 'data-mens-mix';
        } else if (gender === 'women') {
          if (category == 'footwear') matchAttr = 'data-womens-shoes';
          else if (category == 'insole' || category == 'sock') matchAttr = 'data-womens-mix';
        }

        let handles = rec_target.getAttribute(matchAttr).split(',');
        rec_target.innerHTML = `
          <ul class="flex flex-col gap-3.5">
            ${(handles).map( handle => 
              `<li>
                <intersection-loader 
                  data-url="/products/${ handle }"
                  data-section-id="rec-tile"
                  class="aspect-auto h-[60px] w-full loading flex items-center justify-center relative"
                >
                  <div class="loader">
                    <span class="block w-8 h-8">
                      <svg class="animate-spin -ml-1 mr-3 h-full w-full text-primaryBrand" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                    </span>
                  </div>
                </intersection-loader>
              </li>`
            ).join('')}
          </ul>`
      }

      modal.replaceChildren(content);
      modal.classList.remove('hidden');
      modal.classList.add('center', 'transition-all', 'duration-500');

      setTimeout(() => {
        document.body.classList.add('overlay');
        modal.querySelector('[data-drawer-action="close"]')?.focus();
        modal.classList.add('top-0', 'bottom-0', 'left-0', 'w-full', 'h-full', 'z-20');
      }, 10);
    }



  }

  customElements.define('mini-cart', MiniCart);
}